import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { Form } from "react-bootstrap";
import OTPInput from "react-otp-input";
import apiClient from "../../services/apiClient";
import CustomButton from "../Button/CustomButton";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { requestNotificationPermission } from "../../services/firebase";

const OTPVerification = ({ handleOTPSubmit, email, onBack, resendOTP }) => {
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (data) => {
    setError(""); // Reset error
    setLoading(true); // Start loading spinner

    try {
      // Request FCM token before authentication
      const fcmToken = await requestNotificationPermission();

      const payload = {
        email_id: email, 
        otp: data.otp, 
        fcm_token_web: fcmToken || null, 
      };

      const response = await apiClient.post(
        "/authUser", // Update with your backend URL
        payload
      );
      console.log(response.data); // Handle successful OTP verification response

      if (fcmToken) {
        console.log("FCM token sent to backend successfully");
      }

      handleOTPSubmit(response);
    } catch (err) {
      console.log("err: ", err);
      if (err?.response?.data) {
        setError(err?.response?.data?.message); // Set error message if API fails
      }
    } finally {
      setLoading(false); // End loading spinner
    }
  };

  return (
    <>
      <div className="w-75">
        <h3 className="title">Let's verify your email</h3>
        <p className="subTitle">
          Check <b>{email}</b> email for the 6-digit verification code.
        </p>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Form.Group controlId="formOTP" className="otpBoxes mb-4">
            <Controller
              name="otp"
              control={control}
              defaultValue=""
              rules={{
                required: "OTP is required",
                validate: (value) => value.length === 6 || "OTP must be 6 digits",
              }}
              render={({ field }) => (
                <OTPInput
                  value={field.value}
                  onChange={field.onChange}
                  numInputs={6}
                  renderInput={(props) => <input {...props} />}
                />
              )}
            />
            {errors.otp && <Form.Text className="text-danger">{errors.otp.message}</Form.Text>}

            {error && <Form.Text className="text-danger">{error}</Form.Text>}
          </Form.Group>
          <p className="resend">
            Did not get code? Click here for{" "}
            <button type="button" onClick={resendOTP}>
              Resend
            </button>
          </p>
          <CustomButton loading={loading} width={"100%"} type="submit" size="large">
            Next
          </CustomButton>
          <CustomButton
            width={"100%"}
            type="button"
            icon={<ArrowBackIosIcon />}
            iconPosition="left"
            variant="text"
            className="my-2"
            onClick={onBack}
          >
            back
          </CustomButton>
        </Form>
      </div>
    </>
  );
};

export default OTPVerification;
